import { Grid } from "@albelli/arc-3-react/lib/Grid";
import { Loader } from "@albelli/arc-3-react/lib/Loader/Loader";
import { Separator } from "@albelli/arc-3-react/lib/Separator/Separator";
import { ErrorBoundary } from "components/common/ErrorBoundary/ErrorBoundary";
import { SideMenu } from "components/common/SideMenu/SideMenu";
import { OverviewMobile } from "components/overview/OverviewMobile/OverviewMobile";
import { useChannel } from "components/_hooks/useChannel";
import { useLocation } from "components/_hooks/useRouter";
import { ScreenSizes, useScreenSize } from "components/_hooks/useScreenSize";
import { globalObject } from "helpers/globalObject";
import { liveChatHelper } from "helpers/liveChatHelper";
import React, { lazy, Suspense, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { routes } from "routes";
import styles from "./Home.module.css";

const Overview = lazy(() => import("components/overview/Overview/Overview"));
const Orders = lazy(() => import("components/orders/Orders/Orders"));
const OrderDetails = lazy(() => import("components/orderDetail/OrderDetails/OrderDetails"));
const Projects = lazy(() => import("components/savedProjects/Projects/Projects"));
const Settings = lazy(() => import("components/settings/Settings/Settings"));
const ChangeEmail = lazy(() => import("components/settings/ChangeEmail/ChangeEmail"));
const PersonalDetailsEdit = lazy(() => import("components/settings/PersonalDetailsEdit/PersonalDetailsEdit"));

export const Home = () => {
  const location = useLocation();
  // using screenSize to hide OverviewMobile on desktop instead of ARC-3 css class
  // because we need to remove Xsell from DOM, not just display: none
  const screenSize = useScreenSize();
  const channel = useChannel();
  useEffect(() => {
    if (!globalObject.disableZendeskChat) {
      liveChatHelper(channel);
    }
  }, [channel]);

  const isNotHome = location.pathname !== routes.home;
  return (
    <div className={`arc3-container ${styles.container}`}>
      <Grid container noSpacing>
        <Separator className="arc3-cell arc3-cell--12-col arc3-no-margin arc3-hide-for-small" />
        <ErrorBoundary>
          <Grid
            cell
            className={`${styles.sideMenu} arc3-no-margin--top`}
            column={4}
            columnDesktop={3}
            hideSmall={isNotHome}
          >
            <SideMenu />
            {screenSize === ScreenSizes.SMALL && <OverviewMobile />}
          </Grid>
        </ErrorBoundary>
        <Grid
          cell
          className={`${styles.contentPage} arc3-no-margin arc3-padding-lg arc3-no-padding-for--small`}
          column={8}
          columnDesktop={9}
        >
          <Suspense fallback={<Loader spaceHolder />}>
            <Switch>
              <ErrorBoundary>
                <div className="arc3-hide-for-small">
                  <Route exact path="/" component={Overview} />
                </div>
                <Route path={routes.savedProjects} component={Projects} />
                <Route exact path={routes.orders} component={Orders} />
                <Route path={routes.orderDetails} component={OrderDetails} />
                <Route path={routes.settings} exact component={Settings} />
                <Route path={routes.changeEmail} component={ChangeEmail} />
                <Route path={routes.personalDetails} component={PersonalDetailsEdit} />
              </ErrorBoundary>
            </Switch>
          </Suspense>
        </Grid>
      </Grid>
    </div>
  );
};
